module.exports = __webpack_public_path__ + "static/media/mini.be79896b.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程锋锐F3E厢式车/mini.png
// module id = 696
// module chunks = 0